<template lang="pug">
div.padding.p-t-0
    report-filter(
        @onOutletChange="applyOutletFilter",
        @onDateChange="applyDateFilter"
    )
        template(slot="title") Stock Return

    div.row
        div.col-md-12
            div.box
                v-server-table(
                    :url="api",
                    :name="tableName",
                    ref="datatable",
                    :columns="columns",
                    :options="options"
                )
                    template(slot="status" slot-scope="props")
                        span.label.green(v-if="props.row.status == 1") Completed
                        span.label.yellow(v-else) In Progress
</template>

<script>
import Event from './stock-return-event';
const exportUrl = 'stock_returns.exportData';

export default {
    data() {
        var that = this;

        return {
            tableName: 'VUETABLE_STOCK_RETURNS',
            columns: [
                'reference_id',
                'name',
                'outlet',
                'supplier',
                'return_date',
                'return_stocks',
                'status',
            ],
            options: {
                columnsClasses: {
                    return_stocks: 'text-center',
                },
                checkbox: {
                    delete_title: 'Delete Stock Return',
                    api_delete: Laroute.route('stock_returns.delete'),
                },
                customFilters: ['outlet_id', 'since', 'until'],
                orderBy: {
                    ascending: false,
                    column: 'reference_id',
                },
                create_btn: {
                    title: 'New Stock Return',
                    action: () => {
                        that.showCreateForm();
                    },
                },
                rowClassCallback: row => 'pointer',
                checkboxDisableCallback: row => {
                    return row.status >= 1;
                },
                rowClickCallback: that.showForm,
                templates: {
                    return_date(h, row) {
                        return this.formattedDate(row.return_date);
                    },
                },
                permission: {
                    create: () => this.permission.SAVE_STOCK_RETURN,
                    delete: () => this.permission.DELETE_STOCK_RETURN,
                },
                csv_url: Laroute.route(exportUrl, { type: 'CSV' }),
                pdf_url: Laroute.route(exportUrl, { type: 'PDF' }),
                xls_url: Laroute.route(exportUrl, { type: 'XLSX' }),
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('stock_returns.index');
        },
    },

    mounted() {
        Event.$on('stock-return-saved', () => {
            this.$refs.datatable.getData();
        });
    },

    methods: {
        showForm(row) {
            this.$router.push(`/${row.id}`);
        },

        showCreateForm() {
            this.$router.push(`/create`);
        },

        applyOutletFilter(outlet) {
            this.$refs.datatable.applyOutletFilter(outlet);
        },

        applyDateFilter(date) {
            this.$refs.datatable.applyDateFilter(date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_return/stock-return-list.vue